// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5m-0";
export var eligibilityCardNotEligible = "_5m-1";